module.exports = __webpack_public_path__ + "static/img/home4.5349cc9f.png";